import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { UserSettingsModels } from '@share-models';

export const UserSettingsActions = createActionGroup({
  source: 'USER-SETTINGS',
  events: {
    'Reset to Initial state': emptyProps(),
    'Set User Settings': props<{
      userSettings: UserSettingsModels.UserSettingsDocument;
    }>(),
    'Get Me': props<{ language: string }>(),
    'Set Interface Language': props<{ lang: string }>(),
  },
});
